export type OrgHistory = {
  history: OrgHistoryModel;
};

export class OrgHistoryModel {
  id: string;
  name: string;
  created: number;

  constructor(org: { orgId: string; name: string }) {
    this.id = org.orgId;
    this.name = org.name;
    this.created = Date.now();
  }
}
